import { useReactiveVar } from '@apollo/client';
import React, { useContext } from 'react';

import useMyPermissions from '../../../apis/graphql/user/useMyPermissions';
import { selectedOrganizationIdVar, userAmsUserIdVar } from '../../../constants';
import { GhostModeContext } from '../../../context/GhostMode/GhostMode';
import { isSellerMode } from '../../../utils/isSellerMode';
import { StyledGhostModeWrapper, StyledLogOut } from './styled';

const SubHeaderContent = (): JSX.Element | null => {
  const selectedOrgId = useReactiveVar(selectedOrganizationIdVar);
  const userId = useReactiveVar(userAmsUserIdVar);
  const { data, loading } = useMyPermissions(userId, selectedOrgId);
  const { handleCloseGhostMode, organizationName } = useContext(GhostModeContext);
  const isSellerModeActive = isSellerMode(data?.roles);

  const { modeName, wrapperTestId, orgNameTestId, exitButtonTestId, exitButtonText } = {
    wrapperTestId: isSellerModeActive ? 'styledSellerModeWrapper' : 'styledGhostModeWrapper',
    modeName: isSellerModeActive ? 'SELLER MODE' : 'GHOST MODE',
    orgNameTestId: isSellerModeActive ? 'sellerModeOrgName' : 'ghostModeOrgName',
    exitButtonTestId: isSellerModeActive ? 'sellerModeExit' : 'ghostModeExit',
    exitButtonText: isSellerModeActive ? 'Exit Seller Mode' : 'Exit Ghost Mode',
  };

  if (loading) {
    return null;
  }

  return (
    <StyledGhostModeWrapper data-testid={wrapperTestId}>
      <div>
        <div>{modeName}</div>
        <span data-testid={orgNameTestId}>{organizationName}</span>
      </div>

      <StyledLogOut onClick={handleCloseGhostMode} data-testid={exitButtonTestId}>
        {exitButtonText}
      </StyledLogOut>
    </StyledGhostModeWrapper>
  );
};

export default SubHeaderContent;
